import { FC } from 'react';
import {
    TbAlertSquareRoundedFilled,
    TbSquareRoundedFilled,
    TbSquareRoundedLetterHFilled,
    TbSquareRoundedLetterLFilled,
    TbSquareRoundedLetterMFilled,
    TbSquareRoundedMinus,
} from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { TaskPriority } from '@/types';

interface TaskPriorityIconProps {
    priority?: TaskPriority | '' | null;
    size?: string | number;
}

const TaskPriorityIcon: FC<TaskPriorityIconProps> = ({ priority, size = '1rem' }): JSX.Element => {
    const { token } = useAntDesignTheme();
    const appearance =
        priority === TaskPriority.URGENT
            ? { color: token.volcano6, Icon: TbAlertSquareRoundedFilled }
            : priority === TaskPriority.HIGH
              ? { color: token.gold6, Icon: TbSquareRoundedLetterHFilled }
              : priority === TaskPriority.MEDIUM
                ? { color: token.orange6, Icon: TbSquareRoundedLetterMFilled }
                : priority === TaskPriority.LOW
                  ? { color: token.cyan6, Icon: TbSquareRoundedLetterLFilled }
                  : null;

    if (!appearance) {
        return <TbSquareRoundedMinus size={size} style={{ color: token.colorTextQuaternary }} />;
    }

    const { Icon } = appearance;

    return (
        <span
            aria-hidden
            style={{
                alignItems: 'center',
                display: 'inline-flex',
                flex: '0 0 auto',
                fontSize: size,
                height: '1em',
                justifyContent: 'center',
                lineHeight: 1,
                position: 'relative',
                width: '1em',
            }}
        >
            <TbSquareRoundedFilled size='1em' style={{ color: token.colorWhite }} />
            <Icon
                size='1em'
                style={{
                    color: appearance.color,
                    inset: 0,
                    position: 'absolute',
                }}
            />
        </span>
    );
};

export default TaskPriorityIcon;
